import React from "react";
import GenericRoutesMap from "components/Routes/GenericRoutesMap";
import { ROUTE_CONFIGS } from "config/routeConfigs";

const RoutesMap = () => {
  const config = ROUTE_CONFIGS.current;
  return (
    <GenericRoutesMap
      routeType="current"
      selector={config.selector}
      loadAction={config.loadAction}
      features={config.features}
    />
  );
};

export default RoutesMap;